import React from 'react';
import { CardNumberElement, CardCvcElement, CardExpiryElement } from '@stripe/react-stripe-js';
import './CardSectionStyles.css';
import { Topography } from 'components/ui';

function CardSection() {
  return (
    <div className="root">
      <Topography.H4>Add new card</Topography.H4>
      <div className="card-inputs-wrapper">
        <label className="input-label">CREDIT OR DEBIT CARD</label>
        <CardNumberElement />

        <label className="input-label">EXPIRATION DATE</label>
        <CardExpiryElement />

        <label className="input-label">CVV</label>
        <CardCvcElement />
      </div>
    </div>
  );
}

export default CardSection;
